/* THE DETAIL DEPOT — motion, quick add, complete kit, cart extras, sticky ATC, popup */
(function () {
  var root = document.documentElement;
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function initMotion() {
    if (!root.classList.contains('dd-motion')) return;
    root.classList.add('dd-motion-ready');
    var sections = document.querySelectorAll('main > .shopify-section, .shopify-section-group-footer-group');
    var childSel = '.dd-stagger, .grid__item, .product__media-wrapper, .product__info-container > *, .accordion, .title-wrapper-with-link, .title-wrapper, .collection-hero__text-wrapper, .footer-block';
    sections.forEach(function (sec) {
      var i = 0;
      sec.querySelectorAll(childSel).forEach(function (el) {
        if (el.parentElement && el.parentElement.closest('.dd-fly')) return;
        el.classList.add('dd-fly');
        el.style.setProperty('--i', Math.min(i++, 10));
      });
    });
    if (!('IntersectionObserver' in window)) { sections.forEach(function (s) { s.classList.add('dd-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('dd-in'); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    sections.forEach(function (s) { io.observe(s); });
  }

  function getDrawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' ? d : null;
  }
  function onCartPage() { return !!document.querySelector('main cart-items'); }

  function initQuickAdd() {
    document.addEventListener('submit', function (evt) {
      var form = evt.target.closest && evt.target.closest('form.dd-quick-add');
      if (!form) return;
      var drawer = getDrawer();
      if (!drawer || !window.routes || onCartPage()) return;
      evt.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.querySelector('span') : null;
      var original = label ? label.textContent : '';
      if (btn) btn.classList.add('is-loading');
      var fd = new FormData(form);
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            if (label) label.textContent = data.description || data.message || 'Unavailable';
            setTimeout(function () { if (label) label.textContent = original; }, 2500);
            return;
          }
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (btn && label) {
            btn.classList.add('is-added'); label.textContent = 'Added';
            setTimeout(function () { btn.classList.remove('is-added'); label.textContent = original; }, 2000);
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  function initBundle() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-dd-bundle]');
      if (!btn) return;
      var ids = (btn.getAttribute('data-dd-bundle') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var msg = btn.parentElement.querySelector('.dd-kit__msg');
      var drawer = getDrawer();
      var body = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
      if (drawer) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      btn.classList.add('is-loading');
      fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { if (msg) msg.textContent = data.description || data.message || 'Something went wrong.'; return; }
          if (msg) msg.textContent = 'Complete kit added to your cart.';
          if (drawer) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
          else window.location.href = shopRoot + 'cart';
        })
        .catch(function () { if (msg) msg.textContent = 'Something went wrong. Please try again.'; })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  }

  function initCartExtras() {
    var OURS = '.dd-cx-progress, .dd-cx-upsell, #ddCxPage';
    var timer = null;
    function fetchExtras() {
      return fetch(shopRoot + '?sections=dd-cart-extras', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var t = document.createElement('div');
          t.innerHTML = d['dd-cart-extras'] || '';
          return t.querySelector('[data-dd-cx]');
        });
    }
    function apply(cx) {
      var inner = document.querySelector('cart-drawer .drawer__inner');
      if (inner) {
        inner.querySelectorAll('.dd-cx-progress, .dd-cx-upsell').forEach(function (n) { n.remove(); });
        var header = inner.querySelector('.drawer__header');
        var footer = inner.querySelector('.drawer__footer');
        var prog = cx && cx.querySelector('.dd-cx-progress');
        var up = cx && cx.querySelector('.dd-cx-upsell');
        if (prog && header) header.after(prog.cloneNode(true));
        if (up && footer) footer.before(up.cloneNode(true));
      }
      var items = document.querySelector('main cart-items');
      if (items) {
        var page = document.getElementById('ddCxPage');
        if (!page) {
          page = document.createElement('div');
          page.id = 'ddCxPage';
          page.className = 'dd-cx dd-cx--page page-width';
          items.after(page);
        }
        page.innerHTML = cx ? cx.innerHTML : '';
      }
    }
    function refresh() {
      clearTimeout(timer);
      timer = setTimeout(function () { fetchExtras().then(apply).catch(function () {}); }, 150);
    }
    function isOurs(m) {
      if (m.target.closest && m.target.closest(OURS)) return true;
      var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes)).filter(function (n) { return n.nodeType === 1; });
      return nodes.length > 0 && nodes.every(function (n) { return n.matches(OURS); });
    }
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { if (!isOurs(list[i])) { refresh(); return; } }
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    var items = document.querySelector('main cart-items');
    if (items) mo.observe(items, { childList: true, subtree: true });
    if (drawer || items) refresh();
  }

  function initStickyAtc() {
    var bar = document.getElementById('ddStickyAtc');
    if (!bar) return;
    var real = document.querySelector('main product-form .product-form__submit');
    if (!real || !('IntersectionObserver' in window)) { bar.remove(); return; }
    var btn = bar.querySelector('[data-dd-satc-btn]');
    var addLabel = btn.textContent.trim();
    function sync() {
      btn.disabled = real.disabled;
      if (real.disabled) { var s = real.querySelector('span'); btn.textContent = s ? s.textContent.trim() : 'Sold out'; }
      else btn.textContent = addLabel;
    }
    sync();
    new MutationObserver(sync).observe(real, { attributes: true, attributeFilter: ['disabled'] });
    btn.addEventListener('click', function () { real.click(); });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
    }).observe(real);
  }

  function initPopup() {
    var pop = document.getElementById('ddPop');
    if (!pop) return;
    if (window.Shopify && window.Shopify.designMode && pop.dataset.editor !== 'true') return;
    var key = 'ddFreeDeliveryPopupSeen';
    try { if (sessionStorage.getItem(key)) return; } catch (e) {}
    var delay = (parseInt(pop.dataset.delay, 10) || 10) * 1000;
    var lastFocus = null;
    function open() {
      var d = document.querySelector('cart-drawer');
      if (d && d.classList.contains('active')) { setTimeout(open, 4000); return; }
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
      var c = pop.querySelector('.dd-pop__close');
      if (c) c.focus({ preventScroll: true });
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    }
    function close() {
      pop.classList.remove('is-open');
      setTimeout(function () { pop.hidden = true; }, 450);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    pop.addEventListener('click', function (e) { if (e.target.closest('[data-dd-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    function start() { setTimeout(open, delay); }
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { initMotion(); initQuickAdd(); initBundle(); initCartExtras(); initStickyAtc(); initPopup(); });
})();